export enum ExpensePaymentType {
    Cash = 1,
    Transfer = 2
}